import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

interface ArticleContentProps {
  content: string;
  className?: string;
}

export function ArticleContent({ content, className }: ArticleContentProps) {
  return (
    <article
      className={cn(
        'prose prose-sm sm:prose-lg max-w-none',
        // Headings - smaller on mobile
        'prose-headings:font-semibold prose-headings:text-gray-900',
        'prose-h1:text-xl prose-h1:sm:text-3xl prose-h1:mb-3 prose-h1:sm:mb-4',
        'prose-h2:text-lg prose-h2:sm:text-2xl prose-h2:mt-6 prose-h2:sm:mt-8 prose-h2:mb-3 prose-h2:sm:mb-4',
        'prose-h3:text-base prose-h3:sm:text-xl prose-h3:mt-4 prose-h3:sm:mt-6 prose-h3:mb-2 prose-h3:sm:mb-3',
        'prose-h4:text-sm prose-h4:sm:text-lg prose-h4:mt-3 prose-h4:sm:mt-4 prose-h4:mb-2',
        // Paragraphs and text
        'prose-p:text-gray-600 prose-p:leading-snug prose-p:my-2',
        'prose-strong:text-gray-900 prose-strong:font-semibold',
        // Links
        'prose-a:text-violet-600 prose-a:no-underline hover:prose-a:underline',
        // Lists - tighter spacing
        'prose-ul:text-gray-600 prose-ol:text-gray-600',
        'prose-ul:my-2 prose-ol:my-2',
        'prose-li:my-0.5 prose-li:leading-snug',
        'prose-li:marker:text-gray-400',
        // Code
        'prose-code:text-violet-600 prose-code:bg-violet-100',
        'prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-sm',
        'prose-code:before:content-none prose-code:after:content-none',
        'prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:rounded-xl',
        // Tables
        'prose-table:border prose-table:border-gray-200',
        'prose-th:bg-gray-50 prose-th:px-4 prose-th:py-2 prose-th:text-left prose-th:font-semibold',
        'prose-td:px-4 prose-td:py-2 prose-td:border-t prose-td:border-gray-200',
        // Blockquotes
        'prose-blockquote:border-l-4 prose-blockquote:border-violet-500',
        'prose-blockquote:bg-violet-50 prose-blockquote:py-1 prose-blockquote:px-4',
        'prose-blockquote:text-gray-700 prose-blockquote:not-italic',
        // Horizontal rules
        'prose-hr:border-gray-200',
        className
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </article>
  );
}
